import { useLocation, useNavigate } from "react-router-dom";
import { useKitchenStore } from "../stores/kitchen.store";
import { useTranslation } from "../i18n";

interface ClientOption {
  id: string;
  name: string;
}

export default function SelectClient() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const setClientId = useKitchenStore((s) => s.setClientId);

  const clients: ClientOption[] = location.state?.clients || [];

  if (clients.length === 0) {
    navigate("/login");
    return null;
  }

  const handleSelect = (id: string) => {
    setClientId(id);
    navigate("/");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-kds-bg">
      <div className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-kds-text">{t("kds.selectClient.title", "Seleziona Ristorante")}</h1>
          <p className="text-kds-muted mt-2">{t("kds.selectClient.question", "A quale ristorante vuoi accedere?")}</p>
        </div>

        <div className="space-y-3">
          {clients.map((client) => (
            <button
              key={client.id}
              onClick={() => handleSelect(client.id)}
              className="w-full bg-kds-surface hover:bg-kds-card border border-kds-muted/30 rounded-lg px-5 py-4 text-left text-kds-text font-medium transition-colors"
            >
              {client.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
